import { Icon, IconProps } from "@chakra-ui/react";

export function BINIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_416_814)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#7A8F9A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#5B6971"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M15.61 39C15.214 39 14.908 38.898 14.692 38.694C14.488 38.478 14.386 38.172 14.386 37.776V27.534C14.386 27.138 14.488 26.838 14.692 26.634C14.908 26.418 15.214 26.31 15.61 26.31H19.93C20.818 26.31 21.574 26.442 22.198 26.706C22.822 26.97 23.296 27.348 23.62 27.84C23.956 28.332 24.124 28.92 24.124 29.604C24.124 30.372 23.902 31.02 23.458 31.548C23.014 32.076 22.408 32.43 21.64 32.61V32.34C22.528 32.472 23.218 32.808 23.71 33.348C24.202 33.888 24.448 34.59 24.448 35.454C24.448 36.582 24.064 37.458 23.296 38.082C22.54 38.694 21.484 39 20.128 39H15.61ZM16.6 37.254H19.84C20.656 37.254 21.256 37.098 21.64 36.786C22.024 36.462 22.216 35.982 22.216 35.346C22.216 34.698 22.024 34.218 21.64 33.906C21.256 33.594 20.656 33.438 19.84 33.438H16.6V37.254ZM16.6 31.692H19.534C20.326 31.692 20.914 31.542 21.298 31.242C21.694 30.93 21.892 30.474 21.892 29.874C21.892 29.274 21.694 28.824 21.298 28.524C20.914 28.212 20.326 28.056 19.534 28.056H16.6V31.692ZM27.9306 39.144C27.5586 39.144 27.2706 39.042 27.0666 38.838C26.8746 38.622 26.7786 38.328 26.7786 37.956V27.354C26.7786 26.97 26.8746 26.676 27.0666 26.472C27.2706 26.268 27.5586 26.166 27.9306 26.166C28.3026 26.166 28.5846 26.268 28.7766 26.472C28.9806 26.676 29.0826 26.97 29.0826 27.354V37.956C29.0826 38.328 28.9866 38.622 28.7946 38.838C28.6026 39.042 28.3146 39.144 27.9306 39.144ZM32.9387 39.144C32.5907 39.144 32.3207 39.048 32.1287 38.856C31.9487 38.664 31.8587 38.388 31.8587 38.028V27.318C31.8587 26.946 31.9487 26.664 32.1287 26.472C32.3207 26.268 32.5667 26.166 32.8667 26.166C33.1427 26.166 33.3467 26.22 33.4787 26.328C33.6227 26.424 33.7907 26.592 33.9827 26.832L40.8767 35.778H40.4087V27.264C40.4087 26.916 40.4987 26.646 40.6787 26.454C40.8707 26.262 41.1407 26.166 41.4887 26.166C41.8367 26.166 42.1007 26.262 42.2807 26.454C42.4607 26.646 42.5507 26.916 42.5507 27.264V38.064C42.5507 38.4 42.4667 38.664 42.2987 38.856C42.1307 39.048 41.9027 39.144 41.6147 39.144C41.3387 39.144 41.1167 39.09 40.9487 38.982C40.7927 38.874 40.6187 38.7 40.4267 38.46L33.5507 29.514H34.0007V38.028C34.0007 38.388 33.9107 38.664 33.7307 38.856C33.5507 39.048 33.2867 39.144 32.9387 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_416_814">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function GenericFileIcon({
  colors = ["#7A8F9A", "#5B6971", "white"],
  ...rest
}: IconProps & { colors?: [string, string, string] }) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1202_793)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill={colors[0]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.3571V21.3571H43.201C43.201 21.3571 36.889 20.0971 37.073 14.6501C37.073 14.6501 37.281 20.3571 43.076 20.3571H56.001Z"
          fill={colors[1]}
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00610352V14.5671C37.098 16.2231 38.202 20.3581 43.202 20.3581H56.002L37.098 0.00610352Z"
          fill={colors[2]}
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_793">
          <rect width="56" height="64" fill={colors[2]} />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function JSONFileIcon(props: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1202_807)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#B09443"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#15442A"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M5.828 39.126C5.492 39.138 5.228 39.048 5.036 38.856C4.844 38.664 4.748 38.418 4.748 38.118C4.748 37.89 4.82 37.692 4.964 37.524C5.096 37.344 5.294 37.248 5.558 37.236L6.098 37.2C6.626 37.164 7.022 37.002 7.286 36.714C7.562 36.414 7.7 35.988 7.7 35.436V27.336C7.7 26.952 7.796 26.664 7.988 26.472C8.192 26.268 8.48 26.166 8.852 26.166C9.224 26.166 9.506 26.268 9.698 26.472C9.902 26.664 10.004 26.952 10.004 27.336V35.418C10.004 36.174 9.866 36.816 9.59 37.344C9.326 37.872 8.93 38.286 8.402 38.586C7.874 38.874 7.22 39.042 6.44 39.09L5.828 39.126ZM17.1233 39.18C16.5953 39.18 16.0673 39.138 15.5393 39.054C15.0113 38.982 14.5133 38.868 14.0453 38.712C13.5773 38.544 13.1573 38.34 12.7853 38.1C12.5693 37.956 12.4193 37.782 12.3353 37.578C12.2513 37.374 12.2213 37.176 12.2453 36.984C12.2813 36.78 12.3593 36.606 12.4793 36.462C12.6113 36.306 12.7733 36.21 12.9653 36.174C13.1573 36.138 13.3673 36.192 13.5953 36.336C14.1233 36.648 14.6813 36.876 15.2693 37.02C15.8573 37.164 16.4753 37.236 17.1233 37.236C18.0713 37.236 18.7613 37.08 19.1933 36.768C19.6253 36.444 19.8413 36.03 19.8413 35.526C19.8413 35.106 19.6853 34.776 19.3733 34.536C19.0733 34.296 18.5513 34.098 17.8073 33.942L15.8273 33.528C14.6873 33.288 13.8353 32.886 13.2713 32.322C12.7193 31.746 12.4433 30.99 12.4433 30.054C12.4433 29.466 12.5633 28.932 12.8033 28.452C13.0433 27.972 13.3793 27.558 13.8113 27.21C14.2553 26.862 14.7773 26.598 15.3773 26.418C15.9893 26.226 16.6613 26.13 17.3933 26.13C18.1133 26.13 18.7973 26.22 19.4453 26.4C20.0933 26.58 20.6753 26.844 21.1913 27.192C21.3833 27.324 21.5093 27.486 21.5693 27.678C21.6413 27.87 21.6593 28.062 21.6233 28.254C21.5873 28.434 21.5033 28.59 21.3713 28.722C21.2393 28.854 21.0713 28.932 20.8673 28.956C20.6753 28.98 20.4533 28.92 20.2013 28.776C19.7573 28.524 19.3073 28.344 18.8513 28.236C18.3953 28.128 17.9033 28.074 17.3753 28.074C16.8233 28.074 16.3493 28.152 15.9533 28.308C15.5573 28.464 15.2513 28.686 15.0353 28.974C14.8313 29.25 14.7293 29.58 14.7293 29.964C14.7293 30.396 14.8733 30.744 15.1613 31.008C15.4493 31.26 15.9413 31.458 16.6373 31.602L18.5993 32.016C19.7873 32.268 20.6693 32.664 21.2453 33.204C21.8333 33.744 22.1273 34.464 22.1273 35.364C22.1273 35.94 22.0073 36.462 21.7673 36.93C21.5393 37.398 21.2033 37.8 20.7593 38.136C20.3273 38.472 19.8053 38.73 19.1933 38.91C18.5813 39.09 17.8913 39.18 17.1233 39.18ZM29.7928 39.18C28.5688 39.18 27.4948 38.91 26.5708 38.37C25.6588 37.83 24.9508 37.074 24.4468 36.102C23.9428 35.118 23.6908 33.966 23.6908 32.646C23.6908 31.65 23.8348 30.756 24.1228 29.964C24.4108 29.16 24.8188 28.476 25.3468 27.912C25.8868 27.336 26.5288 26.898 27.2728 26.598C28.0288 26.286 28.8688 26.13 29.7928 26.13C31.0288 26.13 32.1028 26.4 33.0148 26.94C33.9268 27.468 34.6348 28.218 35.1388 29.19C35.6428 30.162 35.8948 31.308 35.8948 32.628C35.8948 33.624 35.7508 34.524 35.4628 35.328C35.1748 36.132 34.7608 36.822 34.2208 37.398C33.6928 37.974 33.0508 38.418 32.2948 38.73C31.5508 39.03 30.7168 39.18 29.7928 39.18ZM29.7928 37.2C30.5728 37.2 31.2328 37.02 31.7728 36.66C32.3248 36.3 32.7448 35.778 33.0328 35.094C33.3328 34.41 33.4828 33.594 33.4828 32.646C33.4828 31.206 33.1588 30.09 32.5108 29.298C31.8748 28.506 30.9688 28.11 29.7928 28.11C29.0248 28.11 28.3648 28.29 27.8128 28.65C27.2608 28.998 26.8348 29.514 26.5348 30.198C26.2468 30.87 26.1028 31.686 26.1028 32.646C26.1028 34.074 26.4268 35.19 27.0748 35.994C27.7228 36.798 28.6288 37.2 29.7928 37.2ZM39.3176 39.144C38.9696 39.144 38.6996 39.048 38.5076 38.856C38.3276 38.664 38.2376 38.388 38.2376 38.028V27.318C38.2376 26.946 38.3276 26.664 38.5076 26.472C38.6996 26.268 38.9456 26.166 39.2456 26.166C39.5216 26.166 39.7256 26.22 39.8576 26.328C40.0016 26.424 40.1696 26.592 40.3616 26.832L47.2556 35.778H46.7876V27.264C46.7876 26.916 46.8776 26.646 47.0576 26.454C47.2496 26.262 47.5196 26.166 47.8676 26.166C48.2156 26.166 48.4796 26.262 48.6596 26.454C48.8396 26.646 48.9296 26.916 48.9296 27.264V38.064C48.9296 38.4 48.8456 38.664 48.6776 38.856C48.5096 39.048 48.2816 39.144 47.9936 39.144C47.7176 39.144 47.4956 39.09 47.3276 38.982C47.1716 38.874 46.9976 38.7 46.8056 38.46L39.9296 29.514H40.3796V38.028C40.3796 38.388 40.2896 38.664 40.1096 38.856C39.9296 39.048 39.6656 39.144 39.3176 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_807">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function DOCXIcon(props: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_421_833)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.106 0C2.304 0 0.0330048 2.272 0.0330048 5.074V58.915C0.0330048 61.718 2.304 63.989 5.106 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.106 0Z"
          fill="#103F91"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#002758"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M4.61 39C4.214 39 3.908 38.898 3.692 38.694C3.488 38.478 3.386 38.172 3.386 37.776V27.534C3.386 27.138 3.488 26.838 3.692 26.634C3.908 26.418 4.214 26.31 4.61 26.31H8.102C10.226 26.31 11.864 26.856 13.016 27.948C14.18 29.04 14.762 30.606 14.762 32.646C14.762 33.666 14.612 34.572 14.312 35.364C14.024 36.144 13.592 36.804 13.016 37.344C12.452 37.884 11.756 38.298 10.928 38.586C10.112 38.862 9.17 39 8.102 39H4.61ZM5.69 37.092H7.958C8.702 37.092 9.344 37.002 9.884 36.822C10.436 36.63 10.892 36.354 11.252 35.994C11.624 35.622 11.9 35.16 12.08 34.608C12.26 34.044 12.35 33.39 12.35 32.646C12.35 31.158 11.984 30.048 11.252 29.316C10.52 28.584 9.422 28.218 7.958 28.218H5.69V37.092ZM22.7849 39.18C21.5609 39.18 20.4869 38.91 19.5629 38.37C18.6509 37.83 17.9429 37.074 17.4389 36.102C16.9349 35.118 16.6829 33.966 16.6829 32.646C16.6829 31.65 16.8269 30.756 17.1149 29.964C17.4029 29.16 17.8109 28.476 18.3389 27.912C18.8789 27.336 19.5209 26.898 20.2649 26.598C21.0209 26.286 21.8609 26.13 22.7849 26.13C24.0209 26.13 25.0949 26.4 26.0069 26.94C26.9189 27.468 27.6269 28.218 28.1309 29.19C28.6349 30.162 28.8869 31.308 28.8869 32.628C28.8869 33.624 28.7429 34.524 28.4549 35.328C28.1669 36.132 27.7529 36.822 27.2129 37.398C26.6849 37.974 26.0429 38.418 25.2869 38.73C24.5429 39.03 23.7089 39.18 22.7849 39.18ZM22.7849 37.2C23.5649 37.2 24.2249 37.02 24.7649 36.66C25.3169 36.3 25.7369 35.778 26.0249 35.094C26.3249 34.41 26.4749 33.594 26.4749 32.646C26.4749 31.206 26.1509 30.09 25.5029 29.298C24.8669 28.506 23.9609 28.11 22.7849 28.11C22.0169 28.11 21.3569 28.29 20.8049 28.65C20.2529 28.998 19.8269 29.514 19.5269 30.198C19.2389 30.87 19.0949 31.686 19.0949 32.646C19.0949 34.074 19.4189 35.19 20.0669 35.994C20.7149 36.798 21.6209 37.2 22.7849 37.2ZM37.1338 39.18C35.8138 39.18 34.6798 38.916 33.7318 38.388C32.7958 37.848 32.0758 37.092 31.5718 36.12C31.0678 35.136 30.8158 33.978 30.8158 32.646C30.8158 31.65 30.9598 30.756 31.2478 29.964C31.5358 29.16 31.9498 28.476 32.4897 27.912C33.0298 27.336 33.6898 26.898 34.4697 26.598C35.2618 26.286 36.1498 26.13 37.1338 26.13C37.7938 26.13 38.4418 26.214 39.0778 26.382C39.7138 26.55 40.2718 26.79 40.7518 27.102C41.0038 27.258 41.1718 27.45 41.2558 27.678C41.3398 27.894 41.3578 28.11 41.3098 28.326C41.2618 28.53 41.1598 28.704 41.0038 28.848C40.8598 28.992 40.6738 29.076 40.4458 29.1C40.2298 29.112 39.9898 29.034 39.7258 28.866C39.3538 28.626 38.9518 28.452 38.5198 28.344C38.0878 28.236 37.6498 28.182 37.2058 28.182C36.3538 28.182 35.6338 28.356 35.0458 28.704C34.4578 29.052 34.0138 29.556 33.7138 30.216C33.4138 30.876 33.2638 31.686 33.2638 32.646C33.2638 33.594 33.4138 34.404 33.7138 35.076C34.0138 35.748 34.4578 36.258 35.0458 36.606C35.6338 36.954 36.3538 37.128 37.2058 37.128C37.6618 37.128 38.1118 37.074 38.5558 36.966C38.9998 36.846 39.4198 36.666 39.8158 36.426C40.0798 36.27 40.3138 36.204 40.5178 36.228C40.7338 36.24 40.9138 36.312 41.0578 36.444C41.2018 36.576 41.2978 36.744 41.3458 36.948C41.3938 37.14 41.3818 37.344 41.3098 37.56C41.2378 37.764 41.0938 37.944 40.8778 38.1C40.3978 38.448 39.8218 38.718 39.1498 38.91C38.4898 39.09 37.8178 39.18 37.1338 39.18ZM43.6325 39.144C43.3325 39.144 43.0865 39.066 42.8945 38.91C42.7025 38.742 42.5885 38.538 42.5525 38.298C42.5285 38.046 42.6125 37.794 42.8045 37.542L46.9265 32.052V33.042L43.0025 27.786C42.8105 27.522 42.7265 27.27 42.7505 27.03C42.7745 26.778 42.8825 26.574 43.0745 26.418C43.2665 26.25 43.5065 26.166 43.7945 26.166C44.0345 26.166 44.2445 26.226 44.4245 26.346C44.6165 26.454 44.8085 26.64 45.0005 26.904L48.2405 31.368H47.5025L50.7245 26.904C50.9165 26.64 51.1025 26.454 51.2825 26.346C51.4745 26.226 51.6965 26.166 51.9485 26.166C52.2485 26.166 52.4945 26.244 52.6865 26.4C52.8785 26.556 52.9865 26.76 53.0105 27.012C53.0345 27.252 52.9445 27.51 52.7405 27.786L48.8165 33.042V32.052L52.9205 37.542C53.1125 37.794 53.1965 38.046 53.1725 38.298C53.1485 38.538 53.0405 38.742 52.8485 38.91C52.6565 39.066 52.4045 39.144 52.0925 39.144C51.8645 39.144 51.6545 39.084 51.4625 38.964C51.2825 38.844 51.0905 38.652 50.8865 38.388L47.4665 33.708H48.2585L44.8565 38.388C44.6645 38.652 44.4725 38.844 44.2805 38.964C44.0885 39.084 43.8725 39.144 43.6325 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_421_833">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function IMGIcon(props: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1210_793)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#A0B043"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M56.001 20.3571V21.3571H43.201C43.201 21.3571 36.889 20.0971 37.073 14.6501C37.073 14.6501 37.281 20.3571 43.076 20.3571H56.001Z"
          fill="#15442A"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00610352V14.5671C37.098 16.2231 38.202 20.3581 43.202 20.3581H56.002L37.098 0.00610352Z"
          fill="white"
        />
        <path
          d="M13.538 39.144C13.166 39.144 12.878 39.042 12.674 38.838C12.482 38.622 12.386 38.328 12.386 37.956V27.354C12.386 26.97 12.482 26.676 12.674 26.472C12.878 26.268 13.166 26.166 13.538 26.166C13.91 26.166 14.192 26.268 14.384 26.472C14.588 26.676 14.69 26.97 14.69 27.354V37.956C14.69 38.328 14.594 38.622 14.402 38.838C14.21 39.042 13.922 39.144 13.538 39.144ZM18.5461 39.144C18.2101 39.144 17.9521 39.048 17.7721 38.856C17.5921 38.664 17.5021 38.4 17.5021 38.064V27.246C17.5021 26.898 17.5981 26.634 17.7901 26.454C17.9821 26.262 18.2461 26.166 18.5821 26.166C18.8821 26.166 19.1161 26.226 19.2841 26.346C19.4641 26.454 19.6261 26.646 19.7701 26.922L24.2161 35.148H23.6401L28.0861 26.922C28.2301 26.646 28.3861 26.454 28.5541 26.346C28.7221 26.226 28.9561 26.166 29.2561 26.166C29.5921 26.166 29.8501 26.262 30.0301 26.454C30.2101 26.634 30.3001 26.898 30.3001 27.246V38.064C30.3001 38.4 30.2101 38.664 30.0301 38.856C29.8621 39.048 29.6041 39.144 29.2561 39.144C28.9201 39.144 28.6621 39.048 28.4821 38.856C28.3021 38.664 28.2121 38.4 28.2121 38.064V29.73H28.6081L24.8281 36.624C24.7081 36.828 24.5821 36.978 24.4501 37.074C24.3181 37.17 24.1381 37.218 23.9101 37.218C23.6821 37.218 23.4961 37.17 23.3521 37.074C23.2081 36.966 23.0821 36.816 22.9741 36.624L19.1581 29.712H19.5901V38.064C19.5901 38.4 19.5001 38.664 19.3201 38.856C19.1521 39.048 18.8941 39.144 18.5461 39.144ZM39.195 39.18C37.791 39.18 36.603 38.916 35.631 38.388C34.671 37.86 33.939 37.11 33.435 36.138C32.931 35.166 32.679 34.014 32.679 32.682C32.679 31.674 32.823 30.768 33.111 29.964C33.411 29.16 33.837 28.476 34.389 27.912C34.953 27.336 35.637 26.898 36.441 26.598C37.245 26.286 38.157 26.13 39.177 26.13C39.849 26.13 40.521 26.214 41.193 26.382C41.877 26.538 42.519 26.808 43.119 27.192C43.323 27.324 43.455 27.486 43.515 27.678C43.587 27.87 43.599 28.068 43.551 28.272C43.503 28.464 43.413 28.632 43.281 28.776C43.149 28.92 42.981 29.01 42.777 29.046C42.585 29.082 42.369 29.034 42.129 28.902C41.673 28.638 41.211 28.446 40.743 28.326C40.275 28.206 39.753 28.146 39.177 28.146C38.289 28.146 37.539 28.326 36.927 28.686C36.315 29.034 35.853 29.544 35.541 30.216C35.241 30.888 35.091 31.71 35.091 32.682C35.091 34.158 35.445 35.28 36.153 36.048C36.861 36.816 37.911 37.2 39.303 37.2C39.783 37.2 40.269 37.152 40.761 37.056C41.253 36.96 41.733 36.828 42.201 36.66L41.751 37.686V33.852H39.771C39.471 33.852 39.237 33.774 39.069 33.618C38.913 33.462 38.835 33.252 38.835 32.988C38.835 32.712 38.913 32.502 39.069 32.358C39.237 32.214 39.471 32.142 39.771 32.142H42.741C43.041 32.142 43.269 32.226 43.425 32.394C43.593 32.55 43.677 32.778 43.677 33.078V37.452C43.677 37.716 43.623 37.938 43.515 38.118C43.419 38.298 43.257 38.43 43.029 38.514C42.501 38.706 41.895 38.868 41.211 39C40.527 39.12 39.855 39.18 39.195 39.18Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1210_793">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function FileFormatIcon({
  label,
  ...rest
}: { label: string } & IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1214_793)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.106 0C2.304 0 0.0330048 2.272 0.0330048 5.074V58.915C0.0330048 61.718 2.304 63.989 5.106 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.106 0Z"
          fill="#43B09E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.3571V21.3571H43.201C43.201 21.3571 36.889 20.0971 37.073 14.6501C37.073 14.6501 37.281 20.3571 43.076 20.3571H56.001Z"
          fill="#15442A"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00610352V14.5671C37.098 16.2231 38.202 20.3581 43.202 20.3581H56.002L37.098 0.00610352Z"
          fill="white"
        />
        <text
          fill="white"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Nunito, AppleSystem, sans-serif"
          fontSize="18"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="9" y="39.422">
            {label || "VID"}
          </tspan>
        </text>
      </g>
      <defs>
        <clipPath id="clip0_1214_793">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}
